import { IMAGES } from "@/lib/sections";

// Editorial luxury image placeholder. Pass `src` to render a real image, else cinematic placeholder
export const Placeholder = ({ src, alt = "", aspect = "aspect-[4/5]", className = "", caption }) => {
  return (
    <div className={`relative ${aspect} w-full overflow-hidden ${className}`}>
      {src ? (
        <img
          src={src}
          alt={alt}
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-luxe hover:scale-[1.03]"
          loading="eager"
          crossOrigin="anonymous"
        />
      ) : (
        <div className="placeholder-image absolute inset-0 flex items-center justify-center">
          <div className="text-center text-gold/30">
            <div className="font-heading text-3xl tracking-tight">Aarya24KT</div>
            <div className="num-overline mt-2 text-gold/40">Image · Replace</div>
          </div>
        </div>
      )}
      {/* gold hairline frame */}
      <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-gold/10" />
      {caption && (
        <div className="absolute bottom-4 left-4 num-overline text-gold/80">{caption}</div>
      )}
    </div>
  );
};

export { IMAGES };
